export default {
  InvalidCredentials: 1,
  RefreshToken: 2,
  UserAccountIsDisabled: 3,
  UserAccountIsNotActivated: 4
};



// WEBPACK FOOTER //
// ./src/constants/unauthorized-subcodes.js